<div class="col-xl-12 mb-30">
  <div class="card card-statistics h-100">
    <div class="card-body">
      <div class="tab nav-border" style="position: relative;">
        <div class="d-block d-md-flex justify-content-between">
          <div class="d-block w-100">
            <h5 class="card-title border-0 pb-0">Cancel Assignment</h5>
          </div>
          <div class="d-block d-md-flex nav-tabs-custom">
            <ul class="nav nav-tabs" id="myTab" role="tablist">
              <li class="nav-item">
                <a class="nav-link active show" id="months-tab" data-toggle="tab" href="#order" role="tab"
                  aria-controls="months" aria-selected="true">Register Assignment Cancellation</a>
              </li>
              <li class="nav-item">
                <a class="nav-link  show" id="months-tab" data-toggle="tab" href="#mission" role="tab"
                  aria-controls="months" aria-selected="true">Assignment Cancellation Request</a>
              </li>
            </ul>
          </div>
        </div>
        <div class="tab-content" id="myTabContent">
          <div class="tab-pane fade active show" id="order" role="tabpanel" aria-labelledby="months-tab">
            <div class="row mb-30">

              <div class="col-md-12 mb-30" style="margin-top: 20px;">
                <div class="card card-statistics h-100">
                  <div class="card-body">

                    <div class="row">
                      <div class="form-group col-md-6">
                        <label for="exampleInputEmail1">Letter Number</label>
                        <input [(ngModel)]="Filter_Letter" name="Filter_Letter" type="number" class="form-control"
                          placeholder="Type here to search...">
                      </div>
                    </div>
                    <div class="row">
                      <div class="form-group col-md-6">
                        <button *ngIf="!Procssing"  type="button" (click)="ReadData_Schedules()" class="btn btn-info"
                          style="margin-right: 5px;"><i class="fa  fa-search"></i> Search </button>

                        <img *ngIf="Procssing" src="assets/Loading.gif" style="width: 25px;" />
                      </div>
                    </div>



                    <div class="table-responsive">
                      <table class="mb-0 table table-bordered table-3 text-center table-striped">
                        <thead style="background-color: #489b39; color: white;">
                          <tr>
                            <th>#</th>
                            <th>Decree Number</th>
                            <th>Letter Number</th>
                            <th>Customer Name</th>
                            <th>Date</th>
                            <th>Time</th>
                            <th>Actions</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr *ngFor="let item of DataList_Schedules">
                            <td>{{DataList_Schedules.indexOf(item)+1}}</td>
                            <td>{{item.code2}}</td>
                            <td>{{item.code}}</td>
                            <td>{{item.customerName}}</td>
                            <td>{{item.persianDate}}</td>
                            <td>{{item.clock}}</td>
                            <td>
                              <button ype="button" (click)="openModal(template,item)" class="btn btn-danger">Cancel
                                Assignment</button>
                            </td>

                          </tr>
                        </tbody>
                      </table>
                    </div>


                  </div>
                </div>
              </div>


            </div>

          </div>
          <div class="tab-pane fade show" id="mission" role="tabpanel" aria-labelledby="months-tab">

            <br />
            <br />

            <div class="row">
              <div class="form-group col-md-6">
                <button type="button" *ngIf="!InProccessing_SchedulesUser" (click)="ReadData_SchedulesUser()" class="btn btn-info"
                  style="margin-right: 5px;"><i class="fa  fa-search"></i> Search </button>

                <img *ngIf="InProccessing_SchedulesUser" src="assets/Loading.gif" style="width: 25px;" />
              </div>
            </div>

            <div class="table-responsive">
              <table class="mb-0 table table-bordered table-3 text-center table-striped">
                <thead style="background-color: #489b39; color: white;">
                  <tr>
                    <th>#</th>
                    <th>Decree Number</th>
                    <th>Letter Number</th>
                    <th>Customer Name</th>
                    <th>Date</th>
                    <th>Supervisor</th>
                    <th>Request Description</th>
                    <th>Actions</th>
                  </tr>
                </thead>
                <tbody>
                  <tr *ngFor="let item of DataList_SchedulesUser">
                    <td>
                      <p *ngIf="item.dscVisible">{{DataList_SchedulesUser.indexOf(item)+1}}</p>
                      <span *ngIf="!item.dscVisible" class="badge badge-pill badge-info float-right mt-1">New</span>
                    </td>
                    <td>{{item.code2}}</td>
                    <td>{{item.code}}</td>
                    <td>{{item.customerName}}</td>
                    <td>{{item.persianDate}}</td>
                    <td>{{item.activity_user}}</td>
                    <td>{{item.activity_date}}</td>
                    <td>
                      <div *ngIf="!item.DeletingProccess" class="btn-group" role="group">
                        <button id="btnGroupDrop1" type="button" class="btn btn-warning dropdown-toggle" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                            Actions
                        </button>
                        <div class="dropdown-menu" aria-labelledby="btnGroupDrop1">

                          <a style="cursor: pointer;" class="dropdown-item" (click)="openModalCancelScheduleRequest(templateCancelScheduleRequest,item,1)"><i class="fa fa-check"></i> Approve </a>
                          <a style="cursor: pointer;" class="dropdown-item" (click)="openModalCancelScheduleRequest(templateCancelScheduleRequest,item,-1)"><i class="fa fa fa-times-rectangle"></i> Reject </a>
                        </div>
                    </div>

                    </td>

                  </tr>
                </tbody>
              </table>
            </div>


          </div>

        </div>
      </div>
    </div>
  </div>
</div>



<ng-template #template>
  <div class="modal-header">
    <h4 class="modal-title pull-left">Approve Cancel Assignment Order Number <b>{{Data_Seleted_Cancel.code2}}</b> </h4>
    <button type="button" class="close pull-right" aria-label="Close" (click)="modalRef_Cancel.hide()">
      <span aria-hidden="true">×</span>
    </button>
  </div>
  <div class="card-body">
    <div class="row">

      <div class="form-group col-md-12">
        <label for="exampleInputEmail1"> Description </label>
        <input [(ngModel)]="Filter_Dsc" name="Filter_Dsc" type="text" class="form-control "
          placeholder="Type here...">
      </div>

    </div>

  </div>
  <div class="modal-footer">
    <button type="button" [disabled]="!Filter_Dsc" class="btn btn-warning" (click)="Cancel(Data_Seleted_Cancel)"> Cancel
      Assignment <i class="fa fa-times-circle"></i></button>

    <button type="button" class="btn btn-danger" (click)="modalRef_Cancel.hide()">Close</button>
  </div>
</ng-template>

<ng-template #templateCancelScheduleRequest>
  <div class="modal-header">
    <h4 *ngIf="Data_Seleted_Delete_Status==-1" class="modal-title pull-left"> Reject Cancel Order Number '{{DataList_SchedulesUser_Record.code2}}' </h4>
    <h4 *ngIf="Data_Seleted_Delete_Status==1" class="modal-title pull-left">  Approve Cancel Order Number '{{DataList_SchedulesUser_Record.code2}}' </h4>
    <button type="button" class="close pull-right" aria-label="Close" (click)="modalRef_CancelScheduleRequest.hide()">
      <span aria-hidden="true">×</span>
    </button>
  </div>
  <div class="modal-body">
    <div class="row">
      <div class="form-group col-md-12">
        <label for="exampleInputEmail1">Description</label>
        <input [(ngModel)]="OperationDsc_CancelScheduleRequest"  name="OperationDsc_CancelScheduleRequest" type="text" class="form-control"  placeholder="Type here...">
      </div>
    </div>
  </div>
  <div class="modal-footer">
    <button *ngIf="Data_Seleted_Delete_Status==-1" type="button" class="btn btn-danger" (click)="Answer_CancelScheduleRequest()"> Reject <i class="fa fa-times-rectangle"></i></button>
    <button *ngIf="Data_Seleted_Delete_Status==1" type="button" class="btn btn-success" (click)="Answer_CancelScheduleRequest()"> Approve <i class="fa fa-check"></i></button>
    <button type="button" class="btn btn-danger" (click)="modalRef_CancelScheduleRequest.hide()">Close</button>
  </div>
</ng-template>
